import Axios from '../axios.config'
import Router from 'vue-router'
import bus from '../components/bus'

import qs from 'qs'

const dels = []

//判断控件是否重复
function isRepetition(obj) {
  if (obj.type1 === obj.type2) {
    bus.$elementMessage(`${obj.typeName}控件只能添加一个`, 'error')
    return true
  }
  return false
}

export default {
  namespaced: true,

  state: {
    mainResolutionW: 1920,//初始化分辨率
    mainResolutionH: 1080,//初始化分辨率
    taskType: '1',
    percentage: '', //分辨率和屏幕的比例
    previewpercentage: '', //预览分辨率和屏幕的比例
    leftpercentage: '', // 左边场景比例
    templateName: '',
    resolution: '',
    classify: 1,
    fodder: [], //控件素材
    subtitle: '',
    magnification: 1,
    sendFrom: false,
    sendFromq: false,
    templateId: '',
    isAdd: false,
    mycanvas: false,
    form: {
      name: '',
      mainResolution: '1',
      classify: '1',
      taskType: '1',
    },
    isDi: true,
    isItem: true,
    ceEtId: 0,
    clientNos: [],
    ids: [],
    $router: null,
    elementProperty: {
      height: 0,
      width: 0,
      offLeft: 0,
      offTop: 0,
      type: 'bg',
    },
    setId: 0,
    addpronId: '',
    isVice: false,
    programType: 'folder',
    programId: '',
    loadingb: false,
    treeNode: null,
    pid: '',
    height: 0,
    width: 0,
    isBj: true, //是否显示背景
    namereturnp: '',
    isempty: false,
    isShowGridding: false,
    widgets: [],
    dels: [],  //删除过的控件
    widgetNumber: 0,
    sceneList: [{index: 0, scId: ''}],
    sceneIndexPerover: 0, //场景预览index
    widgetIndex: -1,
    title: '',
    heightM: 0,
    isTask: false,
    allScene: {componentsList: [], scBackImg: '', scBackImgSize: '', scBackImgId: ''},
    echoData: {
      color: '#333333', //文字颜色
      FontSize: '16', //文字大小
      rollingSpeed: '1', //滚动速度
      alignment: '5', //滚动速度
      rollingOrientation: '1', //滚动方向
      bjcolor: '', //背景颜色
      content: '', //内容
      effect: '1', //动画效果R
      province: ["110000", "110100", "110101"],
      city: '北京市东城区',
      countDown: new Date().valueOf(),
      font: 0
    }, //回显信息
    rightType: 'bg',
    sceneIndex: 0,
    serverURL: '/',
    MaterialList: [],
  },

  getter: {},

  mutations: {

    setIsAdd(state) {
      state.isAdd = false
      state.isAddlv = false
      state.form.name = ''
      state.mycanvas = false
    },
  },

  actions: {
    //创建画布  并计算缩放值
    addGroupingData({state}, data) {

      //分辨率比例
      const p = state.mainResolutionW / state.mainResolutionH

      //屏幕比例
      const p1 = $('.canvas').width() / $('.canvas').height()

      //屏幕宽度
      const w = $('.canvas').width()
      const sw = state.mainResolutionW

      //屏幕高度
      const h = $('.canvas').height()
      const sh = state.mainResolutionH

      if (p > p1) {
        state.percentage = w / sw
      } else {
        state.percentage = h / sh

      }

    },

    //左场景计算
    leftpreviewCalc({state}) {

      const w = $('.scene').width()
      const h = $('.scene').height()
      const p = state.mainResolutionW / state.mainResolutionH
      const p1 = w / h

      if (p > p1) {
        state.leftpercentage = w / state.mainResolutionW

      } else {
        state.leftpercentage = h / state.mainResolutionH
      }
      $('.leftscene').css({
        width: state.mainResolutionW * state.leftpercentage,
        height: state.mainResolutionH * state.leftpercentage,
      })

    },


    //主屏分辨率
    mainGambian({state}, W) {
      for (let i = 0; i < W[0].length; i++) {
        if (W[0][i].id === W[1]) {
          state.mainResolutionW = parseInt(W[0][i].ruLPixel)
          state.mainResolutionH = parseInt(W[0][i].ruWPixel)
        }
      }
    },

    //删除素材
    deleteImg({state, dispatch}, index) {
      let i = parseInt(index)
      // state.allScene.componentsList[state.widgetNumber].mpList.splice(i, 1)
      state.MaterialList.splice(i, 1)

    },

    //向组件添加素材
    filterImg({dispatch, state}, data) {
      let type = state.elementProperty.type
      state.isDi = true
      switch (type) {
        case 'img':
          console.log(data);
          state.allScene.componentsList[state.widgetNumber].mpList.push({
            'name': data.name,
            'volume': '10',// 音量
            'playParam': '10',// 播放参数
            'cartoon': '1',// 动画
            'mid': data.mtId,// 素材id
            'sort': 1,// 可忽略
            'type': data.type,// 可忽略
            'url': data.url,
          })
          break
        case 'video':
          state.allScene.componentsList[state.widgetNumber].mpList.push({
            'name': data.name,
            'volume': '70',// 音量
            'playParam': '10',// 播放参数
            'cartoon': '1',// 动画
            'mid': data.mtId,// 素材id
            'sort': 1,// 可忽略
            'type': data.type,// 可忽略
            'viewUrl': data.videoViewUrl,
            'url': data.url,
          })
          break
        case 'audio':
          state.allScene.componentsList[state.widgetNumber].mpList.push({
            'name': data.name,
            'volume': '70',// 音量
            'playParam': '10',// 播放参数
            'cartoon': '1',// 动画
            'mid': data.mtId,// 素材id
            'sort': 1,// 可忽略
            'type': data.type,// 可忽略
            'url': data.url,
          })
          break
        case 'mixture':
          let url = ''
          if (data.type === 'img') {
            url = data.url
          } else if (data.type === 'video') {
            url = data.videoViewUrl
          }

          state.allScene.componentsList[state.widgetNumber].mpList.push({
            'volume': '70',// 音量
            'playParam': '10',// 播放参数
            'cartoon': '1',// 动画
            'mid': data.mtId,// 素材id
            'sort': 1,// 可忽略
            'type': data.type,// 可忽略
            'url': url,
            'viewUrl': url,
          })
          break
        case 'date':
          state.allScene.componentsList[state.widgetNumber].txList.push({
            'taContent': (() => {
              const date = new Date()
              const y = date.getFullYear()
              const m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
              const d = (date.getDate() + 1) < 10 ? '0' + (date.getDate()) : (date.getDate())
              return [y, m, d].join('-')
            })(),// 内容
            'taColor': '#333333',// 颜色
            'taNo': '1',// 序号
            'taFontSize': '16',// 字体大小
            'taBgColor': '',// 背景色
            'taMove': '1',// 滚动方向 0左进右出 1右进左出
            'taAddress': '北京市',// 天气地址
            'taMoveSpeed': '1',// 滚动速度 0静止 1慢速 2中速 3快速
            'taAlignment': '5',// 对齐方式 1左上角 2顶部居中 3右上角 4左对齐居中 5居中 6 右对齐居中 7左下角 8 底部居中 9右下角
            'taCountDown': '1567997697444',// 倒计时（s）
            'taFont': '1'
          })
          break
        case 'weeks':
          state.allScene.componentsList[state.widgetNumber].txList.push({
            'taContent': (() => {
              const date = new Date()
              const weeks = ['日', '一', '二', '三', '四', '五', '六']
              const m = date.getDay()
              return '星期' + weeks[m]
            })(),// 内容
            'taColor': '#333333',// 颜色
            'taNo': '1',// 序号
            'taFontSize': '16',// 字体大小
            'taBgColor': '',// 背景色
            'taMove': '1',// 滚动方向 0左进右出 1右进左出
            'taAddress': '北京市',// 天气地址
            'taMoveSpeed': '1',// 滚动速度 0静止 1慢速 2中速 3快速
            'taAlignment': '5',// 对齐方式 1左上角 2顶部居中 3右上角 4左对齐居中 5居中 6 右对齐居中 7左下角 8 底部居中 9右下角
            'taCountDown': '1567997697444',// 倒计时（s）
            'taFont': '1'
          })
          break
        case 'countDown':
          state.allScene.componentsList[state.widgetNumber].txList.push({
            'taContent': '00:00:00',// 内容
            'taColor': '#333333',// 颜色
            'taNo': '1',// 序号
            'taFontSize': '16',// 字体大小
            'taBgColor': '',// 背景色
            'taMove': '1',// 滚动方向 0左进右出 1右进左出
            'taAddress': '北京市',// 天气地址
            'taMoveSpeed': '1',// 滚动速度 0静止 1慢速 2中速 3快速
            'taAlignment': '5',// 对齐方式 1左上角 2顶部居中 3右上角 4左对齐居中 5居中 6 右对齐居中 7左下角 8 底部居中 9右下角
            'taCountDown': function () {
              const date = new Date()
              return date.valueOf()
            }(),// 倒计时（s）
            'taFont': '1',
            'taBgImage': '1'
          })
          break
        case 'time':
          state.allScene.componentsList[state.widgetNumber].txList.push({
            'taContent': (() => {
              const date = new Date()
              const h = date.getHours()
              const m = (date.getMinutes() + 1) < 10 ? '0' + (date.getMinutes() + 1) : (date.getMinutes() + 1)
              const s = (date.getSeconds() + 1) < 10 ? '0' + (date.getSeconds() + 1) : (date.getSeconds() + 1)

              return [h, m, s].join(':')
            })(),// 内容
            'taColor': '#333333',// 颜色
            'taNo': '1',// 序号
            'taFontSize': '16',// 字体大小
            'taBgColor': '',// 背景色
            'taMove': '1',// 滚动方向 0左进右出 1右进左出
            'taAddress': '北京市',// 天气地址
            'taMoveSpeed': '1',// 滚动速度 0静止 1慢速 2中速 3快速
            'taAlignment': '5',// 对齐方式 1左上角 2顶部居中 3右上角 4左对齐居中 5居中 6 右对齐居中 7左下角 8 底部居中 9右下角
            'taCountDown': '1567997697444',// 倒计时（s）
            'taFont': '1'
          })
          break
        case 'weather':
          state.allScene.componentsList[state.widgetNumber].txList.push({
            'taContent': ["110000", "110100", "110101"],// 内容
            'taColor': '#333333',// 颜色
            'taNo': '1',// 序号
            'taFontSize': '16',// 字体大小
            'taBgColor': '',// 背景色
            'taMove': '1',// 滚动方向 0左进右出 1右进左出
            'taAddress': '北京市东城区',// 天气地址
            'taMoveSpeed': '1',// 滚动速度 0静止 1慢速 2中速 3快速
            'taAlignment': '5',// 对齐方式 1左上角 2顶部居中 3右上角 4左对齐居中 5居中 6 右对齐居中 7左下角 8 底部居中 9右下角
            'taCountDown': '1567997697444',// 倒计时（s）
            'taFont': '1'
          })

          break
        case 'subtitle':
          state.allScene.componentsList[state.widgetNumber].txList.push({
            'taContent': '字幕',// 内容
            'taColor': '#333333',// 颜色
            'taNo': '1',// 序号
            'taFontSize': '16',// 字体大小
            'taBgColor': '',// 背景色
            'taMove': '1',// 滚动方向 0左进右出 1右进左出
            'taAddress': '北京市',// 天气地址
            'taMoveSpeed': '1',// 滚动速度 0静止 1慢速 2中速 3快速
            'taAlignment': '5',// 对齐方式 1左上角 2顶部居中 3右上角 4左对齐居中 5居中 6 右对齐居中 7左下角 8 底部居中 9右下角
            'taCountDown': '1567997697444',// 倒计时（s）
            'taFont': '1'
          })

          break
        case 'webPage':
          state.allScene.componentsList[state.widgetNumber].txList = []
          state.allScene.componentsList[state.widgetNumber].txList.push({
            'taContent': data.content,// 内容
            'taColor': '#333333',// 颜色
            'taNo': '1',// 序号
            'taFontSize': '16',// 字体大小
            'taBgColor': '',// 背景色
            'taMove': '1',// 滚动方向 0左进右出 1右进左出
            'taAddress': '北京市',// 天气地址
            'taMoveSpeed': '1',// 滚动速度 0静止 1慢速 2中速 3快速
            'taAlignment': '5',// 对齐方式 1左上角 2顶部居中 3右上角 4左对齐居中 5居中 6 右对齐居中 7左下角 8 底部居中 9右下角
            'taCountDown': '1567997697444',// 倒计时（s）
            'taFont': '1'
          })
          break
        case 'doc':
          state.allScene.componentsList[state.widgetNumber].mpList.splice(0, 1)
          state.allScene.componentsList[state.widgetNumber].mpList.push({
            'name': data.name,
            'volume': '70',// 音量
            'playParam': '10',// 播放参数
            'cartoon': '1',// 动画
            'mid': data.mtId,// 素材id
            'sort': 1,// 可忽略
            'type': data.type,// 可忽略
            'viewUrl': data.videoViewUrl,
          })

          break
        case 'streaming':
          state.allScene.componentsList[state.widgetNumber].txList = []
          state.allScene.componentsList[state.widgetNumber].txList.push({
            'taContent': data.content,// 内容
            'taColor': '#333333',// 颜色
            'taNo': '1',// 序号
            'taFontSize': '16',// 字体大小
            'taBgColor': '',// 背景色
            'taMove': '1',// 滚动方向 0左进右出 1右进左出
            'taAddress': '北京市',// 天气地址
            'taMoveSpeed': '1',// 滚动速度 0静止 1慢速 2中速 3快速
            'taAlignment': '5',// 对齐方式 1左上角 2顶部居中 3右上角 4左对齐居中 5居中 6 右对齐居中 7左下角 8 底部居中 9右下角
            'taCountDown': '1567997697444',// 倒计时（s）
            'taFont': '1'
          })
          break
        case 'button':

          if (state.allScene.componentsList[state.widgetNumber].txList.length === 0) {

            state.allScene.componentsList[state.widgetNumber].txList.push({
              'taContent': '',// 内容
              'taColor': '#333333',// 颜色
              'taNo': '1',// 序号
              'taFontSize': '16',// 字体大小
              'taBgColor': '',// 背景色
              'taMove': '1',// 滚动方向 0左进右出 1右进左出
              'taAddress': '北京市',// 天气地址
              'taMoveSpeed': '1',// 滚动速度 0静止 1慢速 2中速 3快速
              'taAlignment': '5',// 对齐方式 1左上角 2顶部居中 3右上角 4左对齐居中 5居中 6 右对齐居中 7左下角 8 底部居中 9右下角
              'taCountDown': '1567997697444',// 倒计时（s）
              'taBgImage': data && data.url ? data.url : ""
            })
          } else {
            state.allScene.componentsList[state.widgetNumber].txList[0].taBgImage = data.url
          }


          break
      }

      state.isItem = true
    },

    //添加绑定的素材
    addBindMaterial({state}, data) {
      state.allScene.componentsList[state.widgetNumber].children = []
      switch (data.type) {
        case "img":
          data.data.map((item) => {
            state.allScene.componentsList[state.widgetNumber].children.push({
              'name': item.name,
              'volume': '10',// 音量
              'playParam': '10',// 播放参数
              'cartoon': '1',// 动画
              'mid': item.mtId,// 素材id
              'sort': 1,// 可忽略
              'type': item.type,// 可忽略
              'url': item.url,
            })
          })

          break
        case "video":
          data.data.map(item => {
            state.allScene.componentsList[state.widgetNumber].children.push({
              'name': item.name,
              'volume': '70',// 音量
              'playParam': '10',// 播放参数
              'cartoon': '1',// 动画
              'mid': item.mtId,// 素材id
              'sort': 1,// 可忽略
              'type': item.type,// 可忽略
              'viewUrl': item.videoViewUrl,
              'url': item.url,
            })
          })


          break
        case 'webPage':
          state.allScene.componentsList[state.widgetNumber].children.push({
            'taContent': data.data.content,// 内容
            'type': data.type
          })
      }

    },

    //删除控件
    deleteE({state}) {
      state.isItem = true
      state.dels.push(state.allScene.componentsList[state.widgetNumber].id)

      state.widgetNumber = -99
      state.rightType = 'bg'
      state.elementProperty = {
        height: '',
        width: '',
        offLeft: '',
        offTop: '',
        type: 'bg',
      }
    },

    // 清空
    clearE({state}) {
      state.controlList[state.widgetNumber].material = []
      state.controlList[state.widgetNumber].restrain.volume = []
      state.controlList[state.widgetNumber].restrain.Interval = '10'
      state.controlList[state.widgetNumber].restrain.effect = '1'
      state.fodder = []
    },

    //回显控件信息
    echoData({state}, data) {
      state.echoData = data
    },

    //回显方法
    echoFunc({state}, callback) {
      callback()
    },

    sendModel({state}) {
      state.sendFrom = true
    },

    closeNext({state}) {
      state.sendFromq = false
    },

    //发送设备树
    async setThee({state, dispatch}, data) {

      $('#ddds').html('')
      $('#ddds').html(`<div id="admin" class="ztree"></div>`)

      var zTree
      var t = $('#admin')
      let rMenu = $('.rMenu')

      let funcs = {
        RightClick: function (event, tree, treeNode) {
          state.templateId = treeNode.pid
          if (!treeNode) {
            return
          }
          state.pid = treeNode.pid
          funcs.showRMenu(treeNode.type, treeNode.id, event.clientX, event.clientY)
        },
        showRMenu: function (type, id, x, y) {
          rMenu.hide()
          if (type === 'folder' && id !== -1) {
            $('#rMenu_three').show()
          } else if (type === 'program') {
            $('#rMenu_tow').show()
          } else if (type === 'folder' && id === -1) {

            $('#rMenu_one').show()
          }

          rMenu.css({
            'top': y + 'px',
            'left': x + 'px',
            'visibility': 'visible',
          }) //设置右键菜单的位置、可见
          $('body').bind('mousedown', funcs.BodyMouseDown)
        },
        BodyMouseDown: function (event) {
          if (!(event.target.id == 'rMenu' || $(event.target).parents('.rMenu').length > 0)) {
            rMenu.css({
              'visibility': 'hidden',
            })
          }
        },
        fuzzySearch: function (zTreeId, searchField, isHighLight, isExpand) {
          var zTreeObj = $.fn.zTree.getZTreeObj(zTreeId) //获取树对象
          if (!zTreeObj) {
            alert('获取树对象失败')
          }
          var nameKey = zTreeObj.setting.data.key.name //获取name属性的key
          isHighLight = isHighLight === false ? false : true //除直接输入false的情况外,都默认为高亮
          isExpand = isExpand ? true : false
          zTreeObj.setting.view.nameIsHTML = isHighLight //允许在节点名称中使用html,用于处理高亮

          var metaChar = '[\\[\\]\\\\\^\\$\\.\\|\\?\\*\\+\\(\\)]' //js正则表达式元字符集
          var rexMeta = new RegExp(metaChar, 'gi') //匹配元字符的正则表达式

          // 过滤ztree显示数据
          function ztreeFilter(zTreeObj, _keywords, callBackFunc) {
            if (!_keywords) {
              _keywords = '' //如果为空，赋值空字符串
            }

            // 查找符合条件的叶子节点
            function filterFunc(node) {
              if (node && node.oldname && node.oldname.length > 0) {
                node[nameKey] = node.oldname //如果存在原始名称则恢复原始名称
              }
              //node.highlight = false; //取消高亮
              zTreeObj.updateNode(node) //更新节点让之前对节点所做的修改生效
              if (_keywords.length == 0) {
                //如果关键字为空,返回true,表示每个节点都显示
                zTreeObj.showNode(node)
                zTreeObj.expandNode(node, isExpand) //关键字为空时是否展开节点
                return true
              }
              //节点名称和关键字都用toLowerCase()做小写处理
              if (node[nameKey] && node[nameKey].toLowerCase().indexOf(_keywords.toLowerCase()) != -1) {
                if (isHighLight) { //如果高亮，对文字进行高亮处理
                  //创建一个新变量newKeywords,不影响_keywords在下一个节点使用
                  //对_keywords中的元字符进行处理,否则无法在replace中使用RegExp
                  var newKeywords = _keywords.replace(rexMeta, function (matchStr) {
                    //对元字符做转义处理
                    return '\\' + matchStr

                  })
                  node.oldname = node[nameKey] //缓存原有名称用于恢复
                  //为处理过元字符的_keywords创建正则表达式,全局且不分大小写
                  var rexGlobal = new RegExp(newKeywords, 'gi') //'g'代表全局匹配,'i'代表不区分大小写
                  //无法直接使用replace(/substr/g,replacement)方法,所以使用RegExp
                  node[nameKey] = node.oldname.replace(rexGlobal, function (originalText) {
                    //将所有匹配的子串加上高亮效果
                    var highLightText =
                      '<span style="color: whitesmoke;background-color: darkred;">' +
                      originalText +
                      '</span>'
                    return highLightText
                  })
                  zTreeObj.updateNode(node) //update让更名和高亮生效
                }
                zTreeObj.showNode(node) //显示符合条件的节点
                return true //带有关键字的节点不隐藏
              }
              zTreeObj.hideNode(node) // 隐藏不符合要求的节点
              return false //不符合返回false
            }

            var nodesShow = zTreeObj.getNodesByFilter(filterFunc) //获取匹配关键字的节点
            processShowNodes(nodesShow, _keywords) //对获取的节点进行二次处理
          }

          /**
           * 对符合条件的节点做二次处理
           */
          function processShowNodes(nodesShow, _keywords) {
            if (nodesShow && nodesShow.length > 0) {
              //关键字不为空时对关键字节点的祖先节点进行二次处理
              if (_keywords.length > 0) {
                $.each(nodesShow, function (n, obj) {
                  var pathOfOne = obj.getPath() //向上追溯,获取节点的所有祖先节点(包括自己)
                  if (pathOfOne && pathOfOne.length > 0) {
                    // i < pathOfOne.length-1, 对节点本身不再操作
                    for (var i = 0; i < pathOfOne.length - 1; i++) {
                      zTreeObj.showNode(pathOfOne[i]) //显示节点
                      zTreeObj.expandNode(pathOfOne[i], true) //展开节点
                    }
                  }
                })
              } else { //关键字为空则显示所有节点, 此时展开根节点
                var rootNodes = zTreeObj.getNodesByParam('level', '0') //获得所有根节点
                $.each(rootNodes, function (n, obj) {
                  zTreeObj.expandNode(obj, true) //展开所有根节点
                })
              }
            }
          }

          //监听关键字input输入框文字变化事件
          $(searchField).bind('input propertychange', function () {
            function trim(str) { //删除左右两端的空格
              return str.replace(/(^\s*)|(\s*$)/g, '')
            }

            var _keywords = trim($(this).val())
            searchNodeLazy(_keywords) //调用延时处理
          })

          var timeoutId = null

          // 有输入后定时执行一次，如果上次的输入还没有被执行，那么就取消上一次的执行
          function searchNodeLazy(_keywords) {
            if (timeoutId) { //如果不为空,结束任务
              clearTimeout(timeoutId)
            }
            timeoutId = setTimeout(function () {
              ztreeFilter(zTreeObj, _keywords) //延时执行筛选方法
              $(searchField).focus() //输入框重新获取焦点
            }, 100)
          }
        },
      }

      var setting = {
        async: {
          enable: true,
          url: '/etv/selectClientTree.json',
          headers: {
            token: localStorage.getItem('token1'),
          },
          autoParam: ['id=id'],
          otherParam: {
            'onlineState': function () {
              return data[0]
            },
            'clientName': function () {
              return data[1].toLowerCase()
            },
          },
          dataFilter: filter,
        },
        view: {
          dblClickExpand: false,
          showLine: true,
          selectedMulti: false,
        },
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pId',
            rootPId: '',
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
        },
        check: {
          enable: true,
        },
        callback: {
          beforeClick: function (treeId, treeNode) {
          },
          onRightClick: funcs.RightClick,
          beforeRename: function (treeId, treeNode, newName) {

            if (newName.length == 0) {
              bus.$elementMessage('节点名称不能为空', 'error')
              return false
            }

            Axios.post('/etv/updateProCategory.json', qs.stringify({
              name: newName,
              id: treeNode.id,
            })).then(res => {

              if (res.data.code == 0) {

                bus.$elementMessage(bus.$t('tip.xgcg'), 'success')
              } else if (res.data.code == 1) {

                bus.$elementMessage(res.data.msg, 'error')
              }
            })
          },
          onCheck: function () {
            state.program = []
            state.ids = []
            state.clientNos = []
            var zTree = $.fn.zTree.getZTreeObj('admin'),
              checkCount = zTree.getCheckedNodes(true)

            let checkCount_new = checkCount.filter(function (item) {
              if (item.type === 'folder') {
                return false
              } else {
                return true
              }
            })

            for (let i = 0; i < checkCount_new.length; i++) {
              state.clientNos.push(checkCount_new[i].clNo)
              state.ids.push(checkCount_new[i].clId)
            }
          },
        },

      }

      function filter(treeId, parentNode, childNodes) {

        if (childNodes.code == 401) {
          localStorage.removeItem('token1')
          Router.push('/login')
        }
        let data = {}
        data.name = '发送列表'
        data.icon = '/web/static/images/icon/folder.png'
        data.type = 'folder'
        data.open = true
        data.children = childNodes.data.children

        return data

      }

      await function () {
        zTree = $.fn.zTree.init(t, setting)
        funcs.fuzzySearch('admin', '#deviceId', null, true)
      }()
    },

    //新方法创建
    alterElemtNew({state, dispatch}, data) {
      state.widgetIndex++
      state.widgetNumber = state.widgetIndex
      let infoX = data.infoX || 0
      let infoY = data.infoY || 0
      let infoWidth = data.infoWidth || 100
      let infoHeight = data.infoHeight || 100
      state.elementProperty.type = data.engName
      let obj = {
        coType: data.engName,// 控件类型
        coLeftPosition: 0,// 距左边距
        infoX,
        coRightPosition: 0,// 距上边距
        infoY,
        coWidth: 100,// 宽
        infoWidth,
        coHeight: 100,
        infoHeight,
        coActionType: '1',
        coLinkAction: '',
        coScreenProtectTime: -1,
        id: function () {
          const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't']
          let str = ''
          for (let i = 0; i < 12; i++) {
            str += arr[Math.floor(Math.random() * arr.length)]
          }
          return str
        }(),
        coScId: '',
        mpList: [],
        txList: [],
        children: []
      }

      for (let i = 0; i < state.allScene.componentsList.length; i++) {
        if ((state.allScene.componentsList[i].coType === 'area' && data.engName === 'area') && !state.dels.includes(state.allScene.componentsList[i].id)) {
          bus.$elementMessage("区域控价只能添加一个", 'error')
          return
        } else if ((state.allScene.componentsList[i].coType === 'hdmin' && data.engName === 'hdmin') && !state.dels.includes(state.allScene.componentsList[i].id)) {
          bus.$elementMessage("hdmin控价只能添加一个", 'error')
          return
        }
      }

      state.allScene.componentsList.push(obj)
      let names = ['audio', 'img', 'video', 'doc', 'streaming', 'webPage', 'mixture']
      if (!names.includes(data.engName)) {
        dispatch('filterImg')
      }
    },

    //节目列表树
    async pSetTree({state}) {

      state.loadingb = true
      var zTree
      var t = $('#jiemu')
      let rMenu = $('.rMenu')

      let funcs = {
        RightClick: function (event, tree, treeNode) {
          state.namereturnp = treeNode.name
          $('.curSelectedNode').removeClass('curSelectedNode')
          $(event.target).addClass('curSelectedNode')
          state.treeNode = treeNode
          state.programList = []
          state.programList.push(treeNode)
          state.heightM = 0
          if (!treeNode) {
            return
          }

          state.pid = treeNode.pid

          funcs.showRMenu(treeNode.type, treeNode.id, event.clientX, event.clientY, event.screenY)
        },
        showRMenu: function (type, id, x, y, y1) {

          if (id == 1) {
            return
          }
          let H = $(document).height()
          rMenu.hide()
          if (type === 'folder' && id !== -1 && id !== 1) {
            if (H - 100 - y1 <= $('#rMenu_three').height()) {
              y = y - $('#rMenu_three').height()
            }
            $('#rMenu_three').show()
          } else if (type == 'program') {
            if (H - 120 - y1 <= $('#rMenu_tow').height()) {
              y = y - $('#rMenu_tow').height()
            }
            $('#rMenu_tow').show()
          } else if (type === 'folder' && id == -1) {
            if (H - 120 - y1 <= $('#rMenu_one').height()) {
              y = y - $('#rMenu_one').height()
            }
            $('#rMenu_one').show()
          }

          rMenu.css({
            'top': y + 'px',
            'left': x + 'px',
            'visibility': 'visible',
          }) //设置右键菜单的位置、可见
          $('body').bind('mousedown', funcs.BodyMouseDown)
        },
        BodyMouseDown: function (event) {
          if (!(event.target.id == 'rMenu' || $(event.target).parents('.rMenu').length > 0)) {
            rMenu.css({
              'visibility': 'hidden',
            })
          }
        },
        fuzzySearch: function (zTreeId, searchField, isHighLight, isExpand) {
          var zTreeObj = $.fn.zTree.getZTreeObj(zTreeId) //获取树对象
          if (!zTreeObj) {
            alert('获取树对象失败')
          }
          var nameKey = zTreeObj.setting.data.key.name //获取name属性的key
          isHighLight = isHighLight === false ? false : true //除直接输入false的情况外,都默认为高亮
          isExpand = isExpand ? true : false
          zTreeObj.setting.view.nameIsHTML = isHighLight //允许在节点名称中使用html,用于处理高亮

          var metaChar = '[\\[\\]\\\\\^\\$\\.\\|\\?\\*\\+\\(\\)]' //js正则表达式元字符集
          var rexMeta = new RegExp(metaChar, 'gi') //匹配元字符的正则表达式

          // 过滤ztree显示数据
          function ztreeFilter(zTreeObj, _keywords, callBackFunc) {
            if (!_keywords) {
              _keywords = '' //如果为空，赋值空字符串
            }

            // 查找符合条件的叶子节点
            function filterFunc(node) {
              if (node && node.oldname && node.oldname.length > 0) {
                node[nameKey] = node.oldname //如果存在原始名称则恢复原始名称
              }
              //node.highlight = false; //取消高亮
              zTreeObj.updateNode(node) //更新节点让之前对节点所做的修改生效
              if (_keywords.length == 0) {
                //如果关键字为空,返回true,表示每个节点都显示
                zTreeObj.showNode(node)
                zTreeObj.expandNode(node, isExpand) //关键字为空时是否展开节点
                return true
              }
              //节点名称和关键字都用toLowerCase()做小写处理
              if (node[nameKey] && node[nameKey].toLowerCase().indexOf(_keywords.toLowerCase()) != -1) {
                if (isHighLight) { //如果高亮，对文字进行高亮处理
                  //创建一个新变量newKeywords,不影响_keywords在下一个节点使用
                  //对_keywords中的元字符进行处理,否则无法在replace中使用RegExp
                  var newKeywords = _keywords.replace(rexMeta, function (matchStr) {
                    //对元字符做转义处理
                    return '\\' + matchStr
                  })
                  node.oldname = node[nameKey] //缓存原有名称用于恢复
                  //为处理过元字符的_keywords创建正则表达式,全局且不分大小写
                  var rexGlobal = new RegExp(newKeywords, 'gi') //'g'代表全局匹配,'i'代表不区分大小写
                  //无法直接使用replace(/substr/g,replacement)方法,所以使用RegExp
                  node[nameKey] = node.oldname.replace(rexGlobal, function (originalText) {
                    //将所有匹配的子串加上高亮效果
                    var highLightText = originalText
                    return highLightText
                  })
                  zTreeObj.updateNode(node) //update让更名和高亮生效
                }
                zTreeObj.showNode(node) //显示符合条件的节点
                return true //带有关键字的节点不隐藏
              }
              zTreeObj.hideNode(node) // 隐藏不符合要求的节点
              return false //不符合返回false
            }

            var nodesShow = zTreeObj.getNodesByFilter(filterFunc) //获取匹配关键字的节点

            processShowNodes(nodesShow, _keywords) //对获取的节点进行二次处理
          }

          /**
           * 对符合条件的节点做二次处理
           */
          function processShowNodes(nodesShow, _keywords) {

            if (nodesShow && nodesShow.length > 0) {
              //关键字不为空时对关键字节点的祖先节点进行二次处理
              if (_keywords.length > 0) {
                $.each(nodesShow, function (n, obj) {
                  var pathOfOne = obj.getPath() //向上追溯,获取节点的所有祖先节点(包括自己)
                  if (pathOfOne && pathOfOne.length > 0) {
                    // i < pathOfOne.length-1, 对节点本身不再操作
                    for (var i = 0; i < pathOfOne.length - 1; i++) {
                      zTreeObj.showNode(pathOfOne[i]) //显示节点
                      zTreeObj.expandNode(pathOfOne[i], true) //展开节点
                    }
                  }
                })
              } else { //关键字为空则显示所有节点, 此时展开根节点
                var rootNodes = zTreeObj.getNodesByParam('level', '0') //获得所有根节点
                $.each(rootNodes, function (n, obj) {
                  zTreeObj.expandNode(obj, true) //展开所有根节点
                })
              }
            }
          }

          //监听关键字input输入框文字变化事件
          $(searchField).bind('input propertychange', function () {
            function trim(str) { //删除左右两端的空格
              return str.replace(/(^\s*)|(\s*$)/g, '')
            }

            var _keywords = trim($(this).val())
            searchNodeLazy(_keywords) //调用延时处理
          })

          var timeoutId = null

          // 有输入后定时执行一次，如果上次的输入还没有被执行，那么就取消上一次的执行
          function searchNodeLazy(_keywords) {
            if (timeoutId) { //如果不为空,结束任务
              clearTimeout(timeoutId)
            }
            timeoutId = setTimeout(function () {
              ztreeFilter(zTreeObj, _keywords) //延时执行筛选方法

              $(searchField).focus() //输入框重新获取焦点
            }, 100)
          }
        },
      }

      var setting = {
        async: {
          enable: true,
          url: '/etv/selectProgramCategoryAlls.json',
          autoParam: ['id=id'],
          headers: {
            token: localStorage.getItem('token1'),
          },
          otherParam: {
            'id': function () {
              return state.programId
            },
            type: function () {
              return state.programType
            },
          },
          dataFilter: filter,
        },
        view: {
          dblClickExpand: false,
          showLine: true,
          selectedMulti: false,
        },
        data: {

          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pId',
            rootPId: '',
          },
        },
        callback: {
          beforeClick: function (treeId, treeNode) {

            $('.curSelectedNode').removeClass('curSelectedNode')
          },
          onRightClick: funcs.RightClick,
          /*beforeRename: function (treeId, treeNode, newName) {

            if (newName.length == 0) {
              bus.$elementMessage("节点名称不能为空", "error")
              return false
            }


          },*/
        },
      }

      function filter(treeId, parentNode, childNodes) {

        if (childNodes.code == 401) {
          localStorage.removeItem('token1')
          Router.push('/login')
        }

        if (parentNode) {

          if (childNodes.data.pmList) {
            let data = childNodes.data.pmList[0]
            state.programList = []
            state.programList.push(data)
            state.heightM = 0
            return data
          } else if (childNodes.data.pcList) {
            let data = childNodes.data.pcList[0]
            data.children = []
            return data
          }
        } else {

          if (state.programType == 'folder') {
            let data = {}
            data.name = '节目分组'
            data.id = -1
            data.type = 'folder'
            data.icon = '/web/static/images/icon/folder.png'
            data.open = true
            let data_new = JSON.parse(JSON.stringify(childNodes.data.pcList))
            data.children = data_new
            state.loadingb = false
            return data
          } else if (state.programType == 'file') {
            let data = childNodes.data.pmList[0]
            return data
          }

        }
      }

      await function () {
        zTree = $.fn.zTree.init(t, setting)
        funcs.fuzzySearch('jiemu', '#searchb', null, true)
      }()
    },

    //局部刷新
    refreshParentNodeP({state}, data) {

      var zTree = $.fn.zTree.getZTreeObj('jiemu'),
        type = false,
        silent = 'add'
      try {
        var tree = zTree.getNodesByParam('id', data[0])[0]
      } catch (e) {
        var tree = state.treeNode
      }

      state.programId = data[0]
      state.programType = data[1]
      if (data[2] === 'add') {
        tree = state.treeNode
      }

      zTree.reAsyncChildNodes(tree, type, silent)
      if (!silent) zTree.selectNode(state.treeNode)

    },
  },

}



// WEBPACK FOOTER //
// ./src/store/program_store.js